import { Toaster } from "sonner";

// Layout Components
import Navigation from "../components/layout/Navigation";
import Footer from "../components/layout/Footer";

// Section Components
import HeroSection from "../components/sections/HeroSection";
import ProprietairesSection from "../components/sections/ProprietairesSection";
import ProblemSection from "../components/sections/ProblemSection";
import ApproachSection from "../components/sections/ApproachSection";
import ServicesSection from "../components/sections/ServicesSection";
import WhySylvaSection from "../components/sections/WhySylvaSection";
import WhoWeWorkWithSection from "../components/sections/WhoWeWorkWithSection";
import CarbonSection from "../components/sections/CarbonSection";
import CTAFinalSection from "../components/sections/CTAFinalSection";
import AboutSection from "../components/sections/AboutSection";
import ContactSection from "../components/sections/ContactSection";

const HomePage = () => {
  return (
    <>
      <Navigation />
      <main>
        <HeroSection />
        <ProprietairesSection />
        <ProblemSection />
        <ApproachSection />
        <ServicesSection />
        <WhySylvaSection />
        <WhoWeWorkWithSection />
        <CarbonSection />
        <CTAFinalSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
